import * as React from 'react';
import styled, {css} from 'styled-components';
import {DraggableProvided, DraggableStateSnapshot} from 'react-beautiful-dnd';
import {transparentize} from 'polished';
import {IconDraggable} from 'icons';
import {transition} from 'helpers/css';

export interface DragControlProps {
  provided?: DraggableProvided;
  snapshot?: DraggableStateSnapshot;
}

const Container = styled.div<Partial<DraggableStateSnapshot>>`
  padding: 10px 12px;
  ${transition()};
  
  ${({isDragging, isDropAnimating}) => isDragging && !isDropAnimating ? css`
    color: ${({theme}) => theme.colors.primary};
  ` : css`
    color: ${({theme}) => `
      ${transparentize(.85, theme.variables.color)};
    `};
  `};
`;

/**
 * This component renders the drag control.
 * @param {DragControlProps} props
 * @constructor
 */
export default function DragControl(
    props: DragControlProps,
): React.ReactElement {
  return (
    <Container
      {...props.provided?.dragHandleProps}
      {...props.snapshot}
    >
      <IconDraggable />
    </Container>
  );
}
